import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { themesMixin } from '../../utils/themes';
import ApiService from '../../services/apiService';
export default {
  name: 'CoreExportDialog',
  mixins: [themesMixin],
  props: {
    jobType: {
      type: String,
      required: false,
      default: function _default() {
        return 'export';
      }
    },
    useBackgroundRunnerExport: {
      type: Boolean,
      required: false,
      default: function _default() {
        return false;
      }
    },
    tenantId: {
      type: Number,
      required: true
    },
    exportButtonIcon: {
      type: String,
      required: false,
      default: 'fa-file-csv'
    },
    format: {
      type: String,
      required: true
    },
    resource: {
      type: String,
      required: false,
      default: ''
    },
    query: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    formValid: {
      type: Boolean,
      required: false,
      default: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;

    return {
      valid: this.formValid,
      name: '',
      email: '',
      emailRules: [function (v) {
        return !v || /.+@.+\..+/.test(v) || _this.$i18n_t('Common.emailValid');
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    backgroundColor: function backgroundColor() {
      return "background-color: ".concat(this.vuetifyColorHex('info'));
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    borderColor: function borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    }
  }),
  methods: {
    submit: function submit() {
      var _this2 = this;

      var search = this.$route.params.id;
      var data = this.useBackgroundRunnerExport ? {
        tenantId: this.tenantId,
        title: this.name,
        type: this.resource === 'virtual-device-state-values' ? 'virtualDevice' : 'digitalTwin',
        deviceId: parseInt(search, 10),
        stateIdentifiers: (this.query.variables || []).map(function (q) {
          return q.key;
        }),
        fromTime: new Date(this.query.time.from).toISOString(),
        toTime: new Date(this.query.time.to).toISOString()
      } : {
        name: this.name,
        type: this.jobType,
        format: this.format,
        resource: this.resource,
        query: this.query,
        notification: this.email ? {
          email: [this.email]
        } : null
      };
      var apiMethod = this.useBackgroundRunnerExport ? ApiService.createBackgroundRunnerSingleExportDeviceStates : ApiService.createBackgroundJob;
      return apiMethod(data).then(function (result) {
        _this2.$emit('close');

        _this2.$snack(_this2.$i18n_t('Core.ExportDialog.snacks.createSuccess'), 'success');

        return result;
      }).catch(function (error) {
        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack('Failed to create background job', 'error');
        }
      });
    }
  }
};